import { useEffect, useState } from 'react';
import type { GQLLocale } from 'graphql-ts-types';

import { useGQLLocale } from '../../../hooks/locale';

export const useFetchValidations = <T>(fetchFn: (locale: GQLLocale) => Promise<T>) => {
  const locale = useGQLLocale();

  const [rules, setRules] = useState<T | null>(null);

  useEffect(() => {
    (async function () {
      const fetchedRules = await fetchFn(locale);
      setRules(fetchedRules ? (fetchedRules as T) : null);
    })();
  }, [locale]);

  return rules;
};
